import React, { useState, useEffect, useRef, useMemo } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector } from "react-redux"; // useDispatch

//API
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import ItemService from "../../../../services/customer_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";

import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";

// import ApproveRemarksModal from "../../../../Components/Modal/supplier_app/ApproveRemarksModal";
// import SuccessModal from "../../../../Components/Modal/supplier_app/SuccessModal";
import toast from "react-hot-toast";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import PrintInvoice from "../Scheduling/PrintInvoice";
import { useReactToPrint } from "react-to-print";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import MaterialSelectionModal from "../Scheduling/MaterialSelectionModal";
import { getTodayDate } from "../../../../common/Validations";

const CustInvoiceDetailsV2_Edite = () => {
  // const dispatch = useDispatch();
    const pageStyle = `
  @page {
    size: A4 portrait; /* Sets the paper size to A3, in portrait orientation */
    margin: 10mm;     /* Optional: Sets a small margin for the page */
  }
 
  /* Optional: Targeting the body inside the print document for better fill */
  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
    }
  }
`;

  localStorage.setItem("menu", "Order");
  localStorage.setItem("submenu", "Invoice");

  let invoiceNumber = useSelector((state) => state?.preSales?.invoiceID); // invoiceNumber from Store

  let workflow = useSelector(
    (state) => state?.purchasing?.purchase_order?.workflowPO
  ); // workflowPO from Store

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);

  const [modalShow, setModalShow] = useState(false);

  const [invoiceData, setInvoiceData] = useState();

  // send print data
  const [printInvoiceData, setPrintInvoiceData] = useState();
  // eslint-disable-next-line
  const [getInvoiceChildData, setInvoiceChildData] = useState();

  const [formInputs, setFormInputs] = useState({});

  const [getCompanyCode, setCompanyCode] = useState([]);
  const [getDropdownData, setDropdownData] = useState("");
  const [getCompanyDetails, setCompanyDetails] = useState(null);

  const [othersCustomer, setOthersCustomer] = useState(
    formInputs?.othersCustomerStatus || false
  );
  const [getEditConstant, setEditConstant] = useState(true);

  const [getCustomerDetails, setCustomerDetails] = useState(null);

  const [godownData, setGodownData] = useState([]);
  // eslint-disable-next-line
  const [truckData, setTruckData] = useState([]);

  const [getProductDetailsData, setProductDetailsData] = useState([]); //productDetailsData
  const [totals, setTotals] = useState(formInputs?.totals);

  const defaultCustomerDetails = {
    customerName: "",
    address: "",
    address2: "",
    address3: "",
    state: "",
    cityPostalCode: "",
    certifications: "",
  };

  const lineItemCol = [
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.materialDescription} </p>
          <p className="m-0 p-0 ">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Load confirm Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.orderQtyLoadConfirm} </p>
          {/* <p className="m-0 p-0 pt-1 fw-bold ">{row?.orderQuantityLoad} </p> */}
          <p className="m-0 p-0 ">{row?.uOM} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Unit Price",
      cell: (row) => <span>{row?.unitPrice} </span>,
      width: "100px",
    },
    {
      name: "Basic Price",
      selector: (row) => row?.basicPrice || "--",
      cell: (row) => <span>{row?.basicPrice} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Basic Amt",
      selector: (row) => row.basicAmount || "--",
      cell: (row) => <span>{row.basicAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "CGST",
      selector: (row) => row?.cgstValue || "--",
      cell: (row) => <span>{row?.cgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "SGST",
      selector: (row) => row?.sgstValue || "--",
      cell: (row) => <span>{row?.sgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "GST",
      selector: (row) => row?.gstValue || "--",
      cell: (row) => <span>{row?.gstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },

    {
      name: "CGST%",
      selector: (row) => row?.cgst || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => row?.sgst || "--",
      sortable: true,
      width: "100px",
    },
  ];

  let productDetailsCol = [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      sortable: true,
      width: "80px",
    },
    {
      name: "Material",
      selector: (row) => row.materialLongText,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {row.materialLongText}{" "}
          </p>
          <p className="m-0 p-0 ">{row.materialCode} </p>
        </div>
      ),
    },
    // {
    //   name: "A/C",
    //   selector: (row) => row.accOnOff,
    //   sortable: true,
    //   width: "120px",
    //   cell: (row) => (
    //     <div class="form-check form-switch">
    //       <input
    //         className="form-check-input custom-switch"
    //         type="checkbox"
    //         role="switch"
    //         id={`switch-${row.local_id}`}
    //         checked={row.accOnOff === true}
    //         // onChange={(event) => handleCheckboxChange(row.local_id, event)}
    //       />
    //     </div>
    //   ),
    // },
    {
      name: "UOM",
      selector: (row) => row.uOM || "--",
      sortable: true,
      width: "100px",
    },

    {
      name: "Qty",
      selector: (row) => row.orderQtyLoadConfirm || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderQtyLoadConfirm"
          placeholder=""
          value={row.orderQtyLoadConfirm || ""}
          // disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="unitPrice"
          placeholder=""
          value={row.unitPrice || ""}
          // disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "130px",
    },
    /* 
      {
        name: "Dispatch Date",
        selector: (row) => row.dispatchDate || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="dispatchDate"
            type="date"
            placeholder=""
            // value={row.dispatchDate || getTodayDate("")}
            disabled={false}
            // onChange={(event) => handleInputChange(row.local_id, event)}
          />
        ),
        width: "200px",
      }, */

    {
      name: "Basic Amt",
      selector: (row) => row.basicAmount || "--",
      cell: (row) => <span>{row.basicAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "CGST",
      selector: (row) => row?.cgstValue || "--",
      cell: (row) => <span>{row?.cgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "SGST",
      selector: (row) => row?.sgstValue || "--",
      cell: (row) => <span>{row?.sgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "GST",
      selector: (row) => row?.gstValue || "--",
      cell: (row) => <span>{row?.gstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },

    {
      name: "CGST%",
      selector: (row) => row?.cgst || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => row?.sgst || "--",
      sortable: true,
      width: "100px",
    },

    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button className="" onClick={() => removeProductDetails(row.local_id)}>
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];

  //print
  useEffect(() => {
    setPrintInvoiceData(invoiceData);
  }, [invoiceData]);

  useEffect(() => {
    loadInitialPageData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceNumber]);

  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);
    if (getDropdownData?.textCode === "customerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapDocumentNumber: getDropdownData?.sapDocumentNumber,
      }));
      // getProjectNameData(getDropdownData?.id);
      getCustomerDetail(getDropdownData?.id);
      // setCustomerID(getDropdownData?.id);
      // setFormInputs((formInputs) => ({ ...formInputs, projectName: "" }));
      // setProjectDetails([]);
      // setProjectDetailsSave([]);
    } else if (getDropdownData?.textCode === "projectNameCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
      // getProjectDetailsByCode(getDropdownData?.id);
    } else if (getDropdownData?.textCode === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
      getCompanyMaster(getDropdownData?.id);
      // customerDataDropdown(getDropdownData?.id);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // setValidation((prev) => ({
    //   ...prev,
    //   [getDropdownData?.textField]: "",
    // }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  useEffect(() => {
    loadMasterData();
  }, []);

  useEffect(() => {
    if (formInputs?.companyAddress) {
      setCompanyDetails({
        address: formInputs.companyAddress,
        address2: "",
        address3: "",
        city: "",
        state: "",
      });
    }
    if (formInputs?.othersCustomerStatus !== undefined) {
      setOthersCustomer(formInputs.othersCustomerStatus);
    }
  }, [formInputs]);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  //print
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `Invoice_${invoiceData?.documentNumber}`,
    pageStyle:pageStyle
  });

  const removeProductDetails = (local_id) => {
    setProductDetailsData((prev) => {
      const filteredItems = prev.filter((item) => item.local_id !== local_id);
      const updatedItems = filteredItems.map((item, index) => ({
        ...item,
        local_id: index + 1,
      }));

      return updatedItems;
    });
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // load loadInitialPageData data on page load
  const loadInitialPageData = async () => {
    // setLoading(true);
    if (invoiceNumber) {
      let obj = {
        documentNumber: invoiceNumber,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });

      await ItemServiceV2.getCustInvoiceDatails(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          const invoiceData = item?.data[0] || {};

          // Check if items exist and take the first item's customerAddress
          const firstItem = invoiceData?.items?.[0] || {};

          const updatedInvoiceData = {
            ...invoiceData,
            address: firstItem?.customerAddress || "",
            cityPostalCode: firstItem?.customerPostalCode || "",
            godownAddress: firstItem?.godownAddress || "",
          };
          // console.log(">>updatedInvoiceData",updatedInvoiceData)
          setFormInputs(updatedInvoiceData);
          setInvoiceData(item?.data[0]);
          // setLineItemData(item?.data[0].items);
          setProductDetailsData(item?.data[0].items);
          setEditConstant(item?.data[0]?.manualInvoice===true?true:false)
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      // setLoading(false);
    } else {
      window.history.back();
    }
  };

  // Workflow
  const navigateToWorkflow = () => {
    window.history.back();
  };
  const showApproveModal = async (name) => {
    setModalShow(true);
    // setAction(name);
  };
  const printInvoiceDataChild = (childdData) => {
    setInvoiceChildData(childdData);
  };

  const editInvoice = () => {
    setEditConstant(false);
  };
  const cancelInvoice = () => {
    setEditConstant(true);
  };

  const loadMasterData = async () => {
    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });

    // Get warehouse data
    let obj3 = {
      codeType: "warehouse",
    };
    await ItemService.getMasterData(obj3).then((item) => {
      if (item?.status === 200) {
        setGodownData(item.data || []);
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
    //truck number
    let obj2 = {
      codeType: "truckCode",
    };
    await ItemService.getMasterData(obj2).then((item) => {
      if (item?.status === 200) {
        setTruckData(item.data || []);
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  const getCompanyMaster = async (code) => {
    let obj1 = {
      code: code,
    };
    await ItemServiceV2.getCompanyMaster(obj1).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setCompanyDetails(item?.data[0] || null);
      } else {
        setCompanyDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };

  const onCheckBoxChange = (event) => {
    setOthersCustomer(event.target.checked);
    setCustomerDetails(defaultCustomerDetails);
  };

  // Onselect of Company  will load
  const getCustomerDetail = async (userId) => {
    let obj1 = {
      documentNumber: userId,
    };
    await ItemService.getCustomerDetail(obj1).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setCustomerDetails(item?.data[0] || null);
      } else {
        setCustomerDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };

  const handleInputChange = (local_id, event, type) => {
    const { name, value } = event.target;

    if (type === "Number" && isNaN(value)) {
      toast.error("Please enter a valid number");
      return;
    }

    setProductDetailsData((prevRows) =>
      prevRows.map((row) => {
        if (row.local_id === local_id) {
          const updatedRow = { ...row, [name]: value };

          // Ensure orderQuantityLoad, unitPrice, reversePercentage, basicPrice, and basicAmount are valid numbers
          const orderQtyLoadConfirm =
            parseFloat(updatedRow?.orderQtyLoadConfirm) || 0;
          const unitPrice = parseFloat(updatedRow?.unitPrice) || 0;

          const reversePercentage = parseFloat(updatedRow.reversePercentage);
          const cgst = parseFloat(updatedRow.cgst);
          const sgst = parseFloat(updatedRow.sgst);
          const gst = parseFloat(cgst) + parseFloat(sgst);

          updatedRow.gst = gst;

          // updatedRow.basicPrice =
          //   parseFloat(unitPrice) / parseFloat(reversePercentage);
          updatedRow.basicPrice =
            Math.round((unitPrice / reversePercentage) * 100) / 100;

          // Calculate basicAmount if basicPrice & orderQuantityLoad are valid
          if (!isNaN(updatedRow.basicPrice) && !isNaN(orderQtyLoadConfirm)) {
            // updatedRow.basicAmount = (
            //   updatedRow.basicPrice * orderQuantityLoad
            // ).toFixed(2);
            updatedRow.basicAmount =
              Math.round(
                (unitPrice / reversePercentage) * orderQtyLoadConfirm * 100
              ) / 100;
          }

          // Calculate rate if orderQuantityLoad & unitPrice are valid
          if (!isNaN(orderQtyLoadConfirm) && !isNaN(unitPrice)) {
            // updatedRow.rate = (orderQuantityLoad * unitPrice).toFixed(2);
            updatedRow.rate =
              Math.round(orderQtyLoadConfirm * unitPrice * 100) / 100;
          }

          // Calculate basicPrice if reversePercentage & unitPrice are valid and reversePercentage is not zero
          if (
            !isNaN(reversePercentage) &&
            !isNaN(unitPrice) &&
            reversePercentage !== 0
          ) {
            // updatedRow.basicPrice = (unitPrice / reversePercentage).toFixed(2);
            updatedRow.basicPrice =
              Math.round((unitPrice / reversePercentage) * 100) / 100;
          }

          if (!isNaN(updatedRow.basicAmount)) {
            // updatedRow.cgstValue = (
            //   (cgst * updatedRow.basicAmount) /
            //   100
            // ).toFixed(2);
            updatedRow.cgstValue =
              Math.round(((cgst * updatedRow.basicAmount) / 100) * 100) / 100;
          }

          if (!isNaN(sgst) && !isNaN(updatedRow.basicAmount)) {
            // updatedRow.sgstValue = (
            //   (sgst * updatedRow.basicAmount) /
            //   100
            // ).toFixed(2);
            updatedRow.sgstValue =
              Math.round(((sgst * updatedRow.basicAmount) / 100) * 100) / 100;
          }

          // updatedRow.gstValue = ((gst * updatedRow.basicAmount) / 100).toFixed(
          //   2
          // );
          updatedRow.gstValue = updatedRow.cgstValue + updatedRow.sgstValue;

          updatedRow.netValue = parseFloat(
            parseFloat(updatedRow.gstValue) + parseFloat(updatedRow.basicAmount)
          ).toFixed(2);

          updatedRow.rounded = Math.round(parseFloat(updatedRow.netValue));
          updatedRow.difference = (
            updatedRow.rounded - parseFloat(updatedRow.netValue)
          ).toFixed(2);

          return updatedRow;
        }
        return row;
      })
    );
  };

  const calculatedTotals = useMemo(() => {
    if (!getProductDetailsData || getProductDetailsData.length === 0) {
      return {
        totalBags: 0,
        totalAmount: "0.00",
        totalCgst: "0.00",
        totalSgst: "0.00",
        totalNetValue: "0.00",
      };
    }

    const totals = getProductDetailsData.reduce(
      (acc, item) => {
        acc.totalBags += parseFloat(item.orderQtyLoadConfirm) || 0;
        acc.totalAmount += parseFloat(item.basicAmount) || 0;
        acc.totalCgst += parseFloat(item.cgstValue) || 0;
        acc.totalSgst += parseFloat(item.sgstValue) || 0;
        acc.totalNetValue += parseFloat(item.netValue) || 0;
        return acc;
      },
      {
        totalBags: 0,
        totalAmount: 0,
        totalCgst: 0,
        totalSgst: 0,
        totalNetValue: 0,
      }
    );

    return {
      totalBags: totals?.totalBags,
      totalAmount: totals?.totalAmount.toFixed(2),
      totalCgst: totals?.totalCgst.toFixed(2),
      totalSgst: totals?.totalSgst.toFixed(2),
      totalNetValue: totals?.totalNetValue.toFixed(2),
    };
  }, [getProductDetailsData]);

  useEffect(() => {
    setTotals(calculatedTotals);
  }, [calculatedTotals]);

  const rounded = Math.round(totals?.totalNetValue); // Nearest whole number
  const difference = (rounded - totals?.totalNetValue).toFixed(2);

  /* Modal Function */
  const addProductDetails = () => {
    setModalShow(true);
  };
  const hideModal = () => {
    setModalShow(false);
  };

  const handleGetSelectedMaterial = (selectedData) => {
    setProductDetailsData((prevData) => {
      const updatedData = [
        ...prevData,
        ...selectedData.map((item, index) => ({
          ...item,
          local_id: index + 1, // Continue local_id from previous data
          dispatchDate: getTodayDate(""),
          orderStatus: "Pending",
          orderQuantityLoad: "",
          // shippingAddress: [
          //   getCustomerDetails?.address,
          //   getCustomerDetails?.address2,
          //   getCustomerDetails?.address3,
          //   getCustomerDetails?.state,
          // ]
          //   .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
          //   .join(" "),
          // shippingPostalCode: getCustomerDetails?.cityPostalCode,

          customerAddress: [
            getCustomerDetails?.address,
            getCustomerDetails?.address2,
            getCustomerDetails?.address3,
            getCustomerDetails?.state,
          ]
            .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
            .join(" "),
          customerPostalCode: getCustomerDetails?.cityPostalCode,
          certifications: getCustomerDetails?.certifications,

          companyAddress: [
            getCompanyDetails?.address,
            getCompanyDetails?.address2,
            getCompanyDetails?.address3,
            getCompanyDetails?.city,
            getCompanyDetails?.state,
          ]
            .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
            .join(" "),
          companyPostalCode: getCompanyDetails?.cityPostalCode,
          companyCertifications: getCompanyDetails?.certifications,
        })),
      ];

      // Remove duplicates based on _id
      const uniqueData = Array.from(
        new Map(updatedData.map((item) => [item._id, item])).values()
      );

      // Sort based on `local_id`
      const sortedData = uniqueData
        .map((item, index) => ({
          ...item,
          local_id: index + 1, // Reset local_id sequentially
        }))
        .sort((a, b) => a.local_id - b.local_id);

      return sortedData;
    });
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col>
                <Col xs={12} md={12} lg={12}>
                  <h2 className="mainTitle">
                    Invoice Details :{" "}
                    <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                      {invoiceNumber}
                    </span>
                    <span>
                      {formInputs?.invoiceStatusHeader === "Invoice Created" ? (
                        <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                          {formInputs?.invoiceStatusHeader}
                        </span>
                      ) : formInputs?.invoiceStatusHeader ===
                        "Pending for Approval" ? (
                        <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                          {formInputs?.invoiceStatusHeader}
                        </span>
                      ) : formInputs?.invoiceStatusHeader ===
                        "Invoice Approved" ? (
                        <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                          {formInputs?.invoiceStatusHeader}
                        </span>
                      ) : (
                        formInputs?.invoiceStatusHeader
                      )}
                    </span>
                  </h2>
                  <p className="subText">Invoice Details</p>
                </Col>
              </Col>
            </Row>

            <hr />

            <Row className="mb-4">
              <Col xs={12} md={4} lg={4} className="text-left">
                <button
                  className="btnBack"
                  onClick={() => navigateToWorkflow()}
                >
                  <i className="bi bi-arrow-return-left"></i> Go Back
                </button>
              </Col>
              <Col xs={12} md={4} lg={4} className="text-right">
                {workflow?.workflow_record?.decision?.length > 0 &&
                  workflow?.workflow_record?.decision?.map((item, index) => (
                    <button
                      className={
                        item === "Approve" || item === "Submit"
                          ? "btnCommon btn-approve"
                          : "btnCommon btn-danger"
                      }
                      onClick={() => showApproveModal(item)}
                      key={index}
                    >
                      <i
                        className={
                          item === "Approve" || item === "Submit"
                            ? "bi bi-check2-circle"
                            : "bi bi-x-circle"
                        }
                      ></i>{" "}
                      {item}
                    </button>
                  ))}
              </Col>

              {!getEditConstant && (
                <Col
                  xs={12}
                  md={4}
                  lg={4}
                  className="d-flex justify-content-end"
                >
                  <>
                    <button className="btnBack mr-2">Update</button>
                    <button
                      className="btnBack btn-danger "
                      onClick={cancelInvoice}
                    >
                      Cancel
                    </button>
                  </>
                </Col>
              )}
              
              
          

              {getEditConstant && (<>
                  <Col
                  xs={12}
                  md={2}
                  lg={2}
                  className="d-flex justify-content-end"
                >
               
                    <button className="btnBack" onClick={editInvoice}>
                      Edit
                    </button>
                
                </Col>
                <Col
                  xs={12}
                  md={2}
                  lg={2}
                  className="d-flex justify-content-center"
                >
                  <button className="btnBack" onClick={handlePrint}>
                    <i class="bi bi-printer"></i> Print
                  </button>
                  <div style={{ display: "none" }}>
                    <PrintInvoice
                      ref={contentRef}
                      data={printInvoiceData}
                      onsendinvoicedata={printInvoiceDataChild}
                    />
                  </div>
                </Col>
                </>
              )}
            </Row>
            {/* <div style={{ display: "block" }}>
              <PrintInvoice ref={contentRef} data={printInvoiceData} />
            </div> */}
            {/*  */}

            {!getEditConstant && (
              <>
                {/* Customer Details*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible1
                                ? "bi-chevron-down"
                                : "bi-chevron-right"
                            }`}
                            onClick={toggleCardVisibility1}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">CD</span>
                        </Col>
                        <Col xs={8} md={9} lg={9}>
                          <span className="headerTitle">Customer Details</span>
                          <span className="subHeaderTitle">
                            Customer Details
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible1 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4 d-flex align-items-center">
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Company Name"
                                placeholder=""
                                data={getCompanyCode}
                                id="companyCode"
                                iconClassName="dropdownIcon"
                                name="companyCode"
                                code="companyCode"
                                description="companyCodeDesc"
                                setValue={formInputs.companyCode || ""}
                                getvalue={setDropdownData}
                                required={true}
                                // error={validation.companyCode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <TextAreaField
                                className="inputBox"
                                label="Company Address"
                                name="companyAddress"
                                value={[
                                  getCompanyDetails?.address,
                                  getCompanyDetails?.address2,
                                  getCompanyDetails?.address3,
                                  getCompanyDetails?.city,
                                  getCompanyDetails?.state,
                                ]
                                  .filter(Boolean)
                                  .join(" ")}
                                disabled={true}
                              />
                            </Col>
                          </Row>

                          <Row>
                            {!formInputs?.othersCustomerStatus && (
                              <>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commLeftRightPadding"
                                >
                                  <ComboboxField
                                    label="Customer Name"
                                    placeholder=""
                                    // data={getCustomer}
                                    id="customerName"
                                    iconClassName="dropdownIcon"
                                    name="customerName"
                                    code="customerCode"
                                    description="customerNameDesc"
                                    setValue={formInputs?.customerName || ""}
                                    // getvalue={setDropdownData}
                                    required={true}
                                    // error={validation.customerName}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commLeftRightPadding"
                                >
                                  <TextAreaField
                                    className="inputBox"
                                    label="Customer Address"
                                    name="projectAddress"
                                    value={[
                                      getCustomerDetails?.address,
                                      getCustomerDetails?.address2,
                                      getCustomerDetails?.address3,
                                      getCustomerDetails?.state,
                                      getCustomerDetails?.cityPostalCode,
                                    ]
                                      .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
                                      .join(" ")}
                                    // onChange={onInputChange}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commLeftRightPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Customer Code"
                                    id="customerCode"
                                    name="customerCode"
                                    // type="text"
                                    value={getCustomerDetails?.customerCode}
                                    // onChange={othersOnInputChange}
                                    disabled={true}
                                    // required={true}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commLeftRightPadding d-flex align-items-center"
                                >
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="othersCustomer"
                                      checked={othersCustomer}
                                      onChange={onCheckBoxChange}
                                      disabled
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="othersCustomer"
                                    >
                                      Others
                                    </label>
                                  </div>
                                </Col>
                              </>
                            )}
                          </Row>
                          {formInputs?.othersCustomerStatus && (
                            <Row>
                              <Col
                                xs={12}
                                md={12}
                                lg={12}
                                className="commLeftRightPadding d-flex align-items-center"
                              >
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="othersCustomer"
                                  checked={true}
                                  disabled={true}
                                />
                                <p className="m-0 ps-1 fw-medium text-dark ">
                                  Others{" "}
                                </p>
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Customer Name"
                                  id="customerName"
                                  name="customerName"
                                  // type="text"
                                  value={formInputs?.customerName}
                                  onChange={onInputChange}
                                  // disabled={false}
                                  required={true}
                                  // error={validation.customerName}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <TextAreaField
                                  className="inputBox"
                                  label="Address"
                                  id="address"
                                  name="address"
                                  value={formInputs?.address}
                                  onChange={onInputChange}
                                  // disabled={false}
                                  // error={validation.address}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Pin Code"
                                  id="cityPostalCode"
                                  name="cityPostalCode"
                                  // type="text"
                                  value={formInputs?.cityPostalCode}
                                  onChange={onInputChange}
                                  // disabled={false}
                                  // error={validation.cityPostalCode}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Contact Name"
                                  id="otherCustomerContactName"
                                  name="otherCustomerContactName"
                                  type="text"
                                  value={formInputs?.otherCustomerContactName}
                                  onChange={onInputChange}
                                  // disabled={false}
                                  // error={validation.shippingPostalCode}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Contact Number"
                                  id="otherCustomerContactNumber"
                                  name="otherCustomerContactNumber"
                                  type="text"
                                  value={formInputs?.otherCustomerContactNumber}
                                  onChange={onInputChange}
                                  // disabled={false}
                                  // error={validation.otherCustomerContactNumber}
                                />
                              </Col>
                              <Col xs={12} md={12} lg={12} className="p-2">
                                <p className="fw-bold mb-0">Godown:</p>
                                <Row>
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commLeftRightPadding"
                                  >
                                    <ComboboxField
                                      label="Godown"
                                      placeholder=""
                                      data={godownData}
                                      id="godownAddress"
                                      iconClassName="dropdownIcon"
                                      name="godownAddress"
                                      code="customerCode"
                                      description="godownAddressDesc"
                                      setValue={formInputs?.godownAddress || ""}
                                      getvalue={setDropdownData}
                                      required={true}
                                      // error={validation.godownAddress}
                                    />
                                  </Col>
                                  {/*   <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <ComboboxField
                                  label="Truck Nmber"
                                  placeholder=""
                                  data={truckData}
                                  id="loadingTruckNo"
                                  iconClassName="dropdownIcon"
                                  name="loadingTruckNo"
                                  code="customerCode"
                                  description="loadingTruckNoDesc"
                                  setValue={formInputs?.loadingTruckNo || ""}
                                  getvalue={setDropdownData}
                                  required={true}
                                  // error={validation.loadingTruckNo}
                                />
                              </Col>
                              {formInputs?.loadingTruckNo ===
                                "000 - OTHERS" && (
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commLeftRightPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Truck Nmber"
                                    name="loadingOtherTruckNo"
                                    value={
                                      formInputs?.loadingOtherTruckNo || ""
                                    }
                                    onChange={onInputChange}
                                    // error={validation.loadingOtherTruckNo}

                                    // disabled={true}
                                  />
                                </Col>
                              )}
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Driver Name"
                                  name="transporterDriverName"
                                  value={
                                    formInputs?.transporterDriverName || ""
                                  }
                                  onChange={onInputChange}
                                  // error={validation.transporterDriverName}
                                  // disabled={true}
                                />
                              </Col> */}
                                </Row>
                              </Col>
                            </Row>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Product Details */}
                <div
                  className="accordion sri-venkateshwara mb-4"
                  id="accordionExample"
                >
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible2
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility2}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">CP</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Product Details</span>
                          <span className="subHeaderTitle">
                            Product Details
                          </span>
                        </Col>
                        <Col
                          xs={12}
                          md={2}
                          lg={2}
                          className="headerButtonAlign"
                        >
                          <button
                            className="btnTable"
                            onClick={addProductDetails}
                          >
                            <i className="bi bi-plus-lg"></i> Add
                          </button>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible2 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={productDetailsCol}
                              data={getProductDetailsData}
                              // data={formInputs?.items}
                              // progressPending={loading}
                              // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              // selectableRows
                              // onSelectedRowsChange={handleChange}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Invoice header */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IH</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Invoice Header</span>
                      <span className="subHeaderTitle">Invoice Header</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="mb-0 text-lg">
                            {formInputs?.companyCodeDesc}
                          </p>
                          <p className="mb-0 text-lg">
                            {/* {formInputs?.companyAddress} */}
                            {[
                              getCompanyDetails?.address,
                              getCompanyDetails?.address2,
                              getCompanyDetails?.address3,
                              getCompanyDetails?.city,
                              getCompanyDetails?.state,
                            ]
                              .filter(Boolean)
                              .join(" ")}
                          </p>
                        </Col>
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="fw-bold mb-0">Billing:</p>
                          <p className="text-lg mb-0">
                            {formInputs?.customerName}
                          </p>
                          <p className="text-lg mb-0">
                            {/* {formInputs?.items
                              ? formInputs?.items[0]?.customerAddress
                              : ""} */}
                            {[formInputs?.address, formInputs?.cityPostalCode]
                              .filter(Boolean)
                              .join(" ")}
                          </p>

                          {/* {invoiceData?.items &&
                          invoiceData.items[0]?.certifications
                            ?.filter((doc) =>
                              Object.keys(documentTypeMap).some((type) =>
                                doc.documentType.includes(type)
                              )
                            )
                            .map((doc, index) => {
                              const title =
                                documentTypeMap[doc.documentType] ||
                                doc.documentType; // Fallback to original if not found

                              return (
                                <p key={index} className="fs-5 mb-0">
                                  <b>{title}: </b> {doc.documentNumber}
                                </p>
                              );
                            })} */}
                        </Col>
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="fw-bold mb-0">Shipping:</p>
                          <p className="text-lg mb-0">
                            {/*  {formInputs?.items
                              ? formInputs?.items[0]?.shippingAddress + " "
                              : ""}
                            {formInputs?.items
                              ? formInputs?.items[0]?.shippingPostalCode
                              : ""} */}
                            {[formInputs?.address, formInputs?.cityPostalCode]
                              .filter(Boolean)
                              .join(" ")}
                          </p>
                        </Col>
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="fw-bold mb-0">Godown:</p>
                          <p className="text-lg mb-0">
                            {/* {formInputs?.items
                              ? formInputs?.items[0]?.godownAddress
                              : ""} */}
                            {formInputs?.godownAddress}
                          </p>
                        </Col>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

            {/* invoice service itme details table*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PI</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Items</span>
                      <span className="subHeaderTitle">Items details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={lineItemCol}
                          data={getProductDetailsData}
                          // progressPending={orderSchedulingData?.status}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          // paginationTotalRows={orderSchedulingTable.total}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* invoice details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ID</span>
                    </Col>

                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Invoice details</span>
                      <span className="subHeaderTitle">Invoice details</span>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total Bags"
                                name="sumOfOrderQuantityLoad"
                                id="sumOfOrderQuantityLoad"
                                value={totals?.totalBags}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total Amount"
                                name="sumOfRate"
                                id="sumOfRate"
                                value={totals?.totalAmount}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total CGST"
                                name="totalCgst"
                                id="totalCgst"
                                value={totals?.totalCgst}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total SGST"
                                name="totalSgst"
                                id="totalSgst"
                                value={totals?.totalSgst}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Round Off"
                                name="difference"
                                id="difference"
                                value={difference || ""}
                                // onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Net Amount"
                                name="totalAmount"
                                id="totalAmount"
                                // value={invoiceData?.totals?.totalNetValue}
                                value={rounded || ""}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Row>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                {invoiceData?.items &&
                                !!invoiceData?.items[0]?.loadingOtherTruckNo ? (
                                  <InputField
                                    className="inputBox"
                                    label="Truck No"
                                    name="loadingTruckNo"
                                    id="loadingTruckNo"
                                    value={
                                      invoiceData?.items
                                        ? invoiceData?.items[0]?.loadingOtherTruckNo.toUpperCase()
                                        : ""
                                    }
                                    onChange={onInputChange}
                                    disabled={true}
                                  />
                                ) : (
                                  <InputField
                                    className="inputBox"
                                    label="Truck No"
                                    name="loadingTruckNo"
                                    id="loadingTruckNo"
                                    value={
                                      invoiceData?.items
                                        ? invoiceData?.items[0]
                                            ?.loadingTruckNoDescription
                                        : ""
                                    }
                                    onChange={onInputChange}
                                    disabled={true}
                                  />
                                )}
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="e-Way Bill Number"
                                  extraLabel=""
                                  name="ewayBill"
                                  code="ewayBill"
                                  description="ewayBill"
                                  // data={ewayBillNumberData}
                                  id="ewayBill"
                                  iconClassName="dropdownIcon"
                                  setValue={formInputs?.ewayBill}
                                  // getvalue={setDropdownData}

                                  disabled={true}
                                />
                              </Col>
                              {/* <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Dispatch Documnet Number"
                                    name="dispatchDocumnetNr"
                                    id="dispatchDocumnetNr"
                                    value={invoiceData?.dispatchDocumnetNr}
                                    onChange={onInputChange}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Bill of Lading / LR-RR No."
                                    name="billOfLading"
                                    id="billOfLading"
                                    value={invoiceData?.billOfLading}
                                    onChange={onInputChange}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Terms Of Payment"
                                    extraLabel=""
                                    name="termsOfPayment"
                                    code="termsOfPaymentCode"
                                    description="termsOfPaymentDesc"
                                    // data={dropdownOption}
                                    id="termsOfPayment"
                                    iconClassName="dropdownIcon"
                                    setValue={invoiceData?.termsOfPayment}
                                    // getvalue={setDropdownData}

                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <TextAreaField
                                    className="inputBox"
                                    label="Terms of Delivery"
                                    type="text"
                                    name="termsOfDelivery"
                                    id="termsOfDelivery"
                                    value={invoiceData?.termsOfDelivery}
                                    onChange={onInputChange}
                                    disabled={true}
                                  />
                                </Col> */}
                              {/* {invoiceData?.ewayBill === "Yes" && (
                                  <Row>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Generated Date"
                                        name="generatedDate"
                                        id="generatedDate"
                                        type="date"
                                        value={
                                          invoiceData?.generatedDate ||
                                          getTodaysData()
                                        }
                                        onChange={onInputChange}
                                        disabled={true}
                                        // disabled={!!diableEwaybill}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Distance"
                                        name="distance"
                                        id="distance"
                                        value={invoiceData?.distance}
                                        onChange={onInputChange}
                                        disabled={true}
                                        // disabled={!!diableEwaybill}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Supply Type"
                                        name="supplyType"
                                        id="supplyType"
                                        value={invoiceData?.supplyType}
                                        onChange={onInputChange}
                                        disabled={true}
                                        // disabled={!!diableEwaybill}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Transaction Type"
                                        name="transactionType"
                                        id="transactionType"
                                        value={invoiceData?.transactionType}
                                        onChange={onInputChange}
                                        disabled={true}
                                        // disabled={!!diableEwaybill}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Mode"
                                        name="mode"
                                        id="mode"
                                        value={invoiceData?.mode}
                                        onChange={onInputChange}
                                        disabled={true}
                                        // disabled={!!diableEwaybill}
                                      />
                                    </Col>
                                  </Row>
                                )} */}
                            </Row>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Modal Workflow */}
      {/* <ApproveRemarksModal
        show={modalShow}
        // onHide={() => hideModal()}
        // onvaluechange={handleValueChange}
      /> */}
      <MaterialSelectionModal
        show={modalShow}
        onHide={() => hideModal()}
        onselectedcatdata={handleGetSelectedMaterial}
      />
      {/* Success Modal Workflow */}
      {/* <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
        nextnavigate={getNextNavigate}
      /> */}
    </main>
  );
};

export default CustInvoiceDetailsV2_Edite;
